(() => {
  const script = document.currentScript;
  const endpoint = (script?.dataset.endpoint || '').trim();
  if (!endpoint) return;

  let started = false;
  let heartbeatTimer = null;
  let privacyLoading = false;
  let privacyLoaded = false;
  let privacyRetryAt = 0;

  function analyticsAllowed() {
    return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  }

  function loadPrivacyApi() {
    const shopify = window.Shopify;
    if (
      privacyLoading
      || privacyLoaded
      || typeof shopify?.loadFeatures !== 'function'
      || Date.now() < privacyRetryAt
    ) return;

    privacyLoading = true;
    shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      privacyLoading = false;
      if (error) {
        privacyRetryAt = Date.now() + 3000;
        return;
      }
      privacyLoaded = true;
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed) {
        window.clearInterval(privacyWait);
        start();
      }
    });
  }

  function sessionId() {
    const key = 'ticketmaker_analytics_session';
    let value = sessionStorage.getItem(key);
    if (!value) {
      const randomPart = typeof crypto?.randomUUID === 'function'
        ? crypto.randomUUID()
        : Array.from(crypto.getRandomValues(new Uint8Array(16)), (byte) =>
          byte.toString(16).padStart(2, '0')).join('');
      value = `${Date.now().toString(36)}-${randomPart}`;
      sessionStorage.setItem(key, value);
    }
    return value;
  }

  function campaignData() {
    const key = 'ticketmaker_campaign';
    const params = new URLSearchParams(window.location.search);
    const current = {
      source: params.get('utm_source'),
      medium: params.get('utm_medium'),
      campaign: params.get('utm_campaign'),
    };
    if (current.source || current.medium || current.campaign) {
      sessionStorage.setItem(key, JSON.stringify(current));
      return current;
    }
    try {
      return JSON.parse(sessionStorage.getItem(key) || '{}');
    } catch {
      return {};
    }
  }

  function referrerHost() {
    if (!document.referrer) return null;
    try {
      const host = new URL(document.referrer).hostname;
      return host === window.location.hostname ? null : host;
    } catch {
      return null;
    }
  }

  function send(eventType, detail = {}) {
    if (!analyticsAllowed()) return;
    const campaign = campaignData();
    fetch(endpoint, {
      method: 'POST',
      mode: 'cors',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: sessionId(),
        eventType,
        path: window.location.pathname,
        pageTitle: document.title,
        eventName: detail.eventName || null,
        ticketType: detail.ticketType || null,
        block: detail.block || null,
        seatCount: Number(detail.seatCount) || 0,
        referrerHost: referrerHost(),
        source: campaign.source || null,
        medium: campaign.medium || null,
        campaign: campaign.campaign || null,
      }),
    }).catch(() => {
      // Analytics must never interrupt the storefront.
    });
  }

  function start() {
    if (started || !analyticsAllowed()) return;
    started = true;
    send('page_view');
    if (document.querySelector('[data-jcole-event]')) {
      const root = document.querySelector('[data-jcole-event]');
      send('event_view', { eventName: root?.dataset.eventTitle });
    }
    heartbeatTimer = window.setInterval(() => {
      if (document.visibilityState === 'visible') send('heartbeat');
    }, 20000);
  }

  document.addEventListener('ticketmaker:analytics', (event) => {
    send(event.detail?.eventType, event.detail || {});
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      start();
      if (started) send('heartbeat');
    }
  });
  // Shopify's Customer Privacy API publishes this document event whenever
  // the visitor submits or changes their consent choices.
  document.addEventListener('visitorConsentCollected', start);

  const privacyWait = window.setInterval(() => {
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed) {
      window.clearInterval(privacyWait);
      start();
    } else {
      loadPrivacyApi();
    }
  }, 500);
  window.setTimeout(() => window.clearInterval(privacyWait), 15000);
  window.addEventListener('pagehide', () => {
    if (heartbeatTimer) window.clearInterval(heartbeatTimer);
  }, { once: true });
})();